import React from 'react'

export const SPACE = (
  <>
    Большой, просторный и красивый офис, где найдётся место для каждого кодера.
  </>
)

export const TRADITION = (
  <>
    Каждый день — новые активности:{' '}
    <a>среда — День колбасы, четверг — сырки и йогурты</a>. Всегда есть море
    сладостей, свежие фрукты и вкусные напитки.
  </>
)

export const SPORT = (
  <>
    Мы ценим движение: йога, растяжка, ЛФК несколько раз в неделю. Бегаем
    марафоны, играем в волейбол, ходим на скалолазание. В офисе есть зал с
    тренажёрами и душевые, где можно позаниматься в удобное время.
  </>
)

export const EVENTS = (
  <>
    В офисе регулярно проходят Демодни, где ребята презентуют реализованные
    фичи, а также другие мероприятия для обмена опытом, общения и прокачки
    навыков.
  </>
)
